'use client';

import React, { useRef, useState } from 'react';
import { BiSolidVolumeFull, BiSolidVolumeMute } from 'react-icons/bi';

import BgPattern from '../BgPattern';
import styles from './styles.module.scss';

const Item = props => (
  <div
    style={{
      flex: 1,
      height: 250,
      padding: 22,
      borderRadius: 24,
      position: 'relative',
      overflow: 'hidden',
      border: '1px solid #ffffff42',
    }}
  >
    <BgPattern />

    <div style={{ zIndex: 100, position: 'relative', letterSpacing: '-0.04em' }}>
      <div
        style={{
          fontSize: 70,
          fontFamily: 'var(--brandFont)',
        }}
      >
        {props.heading}
      </div>
      <div style={{ fontSize: 34, lineHeight: '39px' }}>{props.children}</div>
    </div>
  </div>
);

const BentoSection = () => {
  const ref = useRef();
  const [playing, setPlaying] = useState(false);

  return (
    <div className={styles.bentoSection}>
      <div className={styles.firstRow}>
        <BgPattern />
        <div
          onClick={() => {
            setPlaying(!playing);
            if (playing) {
              ref.current.muted = true;
              ref.current.loop = true;
            } else {
              ref.current.currentTime = 0;
              ref.current.muted = false;
              ref.current.loop = false;
              ref.current.play();
            }
          }}
          className={styles.videoContainer}
        >
          <div
            style={{
              position: 'absolute',
              bottom: 8,
              right: 8,
              zIndex: 100,
              color: '#000000b3',
            }}
          >
            {playing ? <BiSolidVolumeFull size={20} /> : <BiSolidVolumeMute size={20} />}
          </div>

          <video
            ref={ref}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              transform: 'scale(1.3) translateY(25px) translateX(4px)',
            }}
            autoPlay
            playsInline
            muted
            loop
          >
            <source
              src="https://d1i6701oxun660.cloudfront.net/Lisa-new.mp4"
              type="video/mp4"
            />
          </video>
        </div>

        <div className={styles.bigCopy}>
          {`Hi there,`}
          <br /> {`I'm Lisa`}
        </div>
      </div>

      <div className={styles.secondRow}>
        <Item heading={'24/7'}>
          Never
          <br />
          stops
          <br />
          working
        </Item>
        <Item heading={'95%'}>
          Less time
          <br />
          reviewing
          <br />
          resumes
        </Item>
        <Item heading={'10X'}>
          More <br />
          candidates
          <br />
          interviewed
        </Item>
        <Item heading={'1%'}>
          Hire the
          <br />
          best talent <br />
          faster
        </Item>
      </div>
    </div>
  );
};

export default BentoSection;
